fx.ns("filters", class LayoutPosterFilter extends fx.Filter {

	constructor(search)
	{
        super();

        this._search = search;
    }

    get search()
    {
        return this._search;
    }

    set search(val)
    {
        this._search = val;
        this._changed = true;
        this.trigger("updated");
    }


    // show recommended/1 photo/2 photos/3 photos/4 photos/more
    // Layout displayed in all cases :
    // - doublepage = 0
    // if doublepage == 1 : displayed only if same page_type_id (covers have slice, so double page layout can not be the same as pages)
	exec()
	{
        if (!this.rawData)
            return;

        this.transformedData = [];
   
        let rawData =(this.search == "recommended") ? this.rawData.sort(function(a, b){  return a.collection_id - b.collection_id }) : this.rawData.sort(function(a, b){  return a.num_photos - b.num_photos });
        let categories = []; 

        for (let i = 0; i < rawData.length; i++)
        {
            let layout = rawData.getItemAt( [i] );

            if (!layout.visible || layout.hasFilteredPhoto) continue;

            if (layout.product_type_id == models.ProductType.POSTER)
            {
                if (this.search == "recommended")
                {
                    if (layout.collection)
                    {
                        if (!categories[layout.collection.name] && fx.browser.isDesktop)
                        {
                            this.transformedData.push( {type : "label", text : layout.collection.name});
                            categories[layout.collection.name] = true;
                        }

                        this.transformedData.push(layout);
                    }   
                }
                else // classical
                {
                    if (!layout.collection)
                    {
                        if (!categories[layout.num_photos] && fx.browser.isDesktop)
                        {
                            this.transformedData.push( {type : "label", text : fx.text("$ photos", layout.num_photos)});
                            categories[layout.num_photos] = true;
                        }
                        this.transformedData.push(layout);   
                    }
             
                }
            }

            
        }        

		return this.transformedData;
	}	

});